import { useQueryClient } from "@tanstack/react-query"
import { useDismissibleNotice } from "Shared/hooks/useDismissibleNotice"
import { useOAuth } from "Shared/hooks/useOAuth"
import { useCallback, useEffect, useState } from "react"
import { useGetPanelistIntegrations } from "~/api/generated/usabilityhub-components"

export const useLinkedinOAuth = (onSuccess: () => void = () => {}) => {
  const queryClient = useQueryClient()
  const { data: panelistIntegrations } = useGetPanelistIntegrations({})
  const [hasLinkedinOAuthCredentials, setHasLinkedinOAuthCredentials] =
    useState(false)
  const { dismiss: dismissableLinkedinVerificationCard } = useDismissibleNotice(
    "linkedin_verification_card"
  )

  useEffect(() => {
    setHasLinkedinOAuthCredentials(!!panelistIntegrations?.linkedin)
  }, [panelistIntegrations])

  const disconnectLinkedinOAuth = useCallback(() => {
    setHasLinkedinOAuthCredentials(false)
    queryClient.invalidateQueries({
      queryKey: ["api", "usercrowd", "integrations"],
    })
    // Dismiss the LinkedIn verification card after disconnecting LinkedIn
    // This is to ensure that the card does not reappear after disconnection
    dismissableLinkedinVerificationCard()
  }, [queryClient, dismissableLinkedinVerificationCard])

  const handleOAuthSuccess = useCallback(() => {
    setHasLinkedinOAuthCredentials(true)
    queryClient.invalidateQueries({
      queryKey: ["api", "usercrowd", "integrations"],
    })
    onSuccess()
  }, [queryClient, onSuccess])

  const { handleWithAuth: handleLinkedinOAuth } = useOAuth(
    handleOAuthSuccess,
    "LinkedIn",
    "/linkedin_oauth2/redirect",
    hasLinkedinOAuthCredentials
  )

  return {
    handleLinkedinOAuth,
    disconnectLinkedinOAuth,
    hasLinkedinOAuthCredentials,
  }
}
